import { useEffect } from "react";
import { useDeviceSetting } from "@-/dev.improve.haniverse.lib.device-settings";
import { startDiagnosticsRecorder, stopDiagnosticsRecorder } from "#diagnostics-recorder";

/**
 * Binds the recorder to the `isDiagnosticsRecordingEnabled` device setting. Mount ONCE at the
 * app root: the recorder starts as soon as the setting is on (including at launch, before any
 * screen renders) and stops when the user turns it off.
 */
export function useDiagnosticsRecorder(): void {
  const [isEnabled] = useDeviceSetting("isDiagnosticsRecordingEnabled");
  useEffect(() => {
    if (isEnabled) {
      startDiagnosticsRecorder();
    } else {
      stopDiagnosticsRecorder();
    }
  }, [isEnabled]);
}
